import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import { isMobile } from "../resources/helpers";
import model, { song } from "../resources/model/model";

interface props {
  toggle: () => any;
  open: boolean;
}

export default function Sidebar({ toggle, open }: props) {
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState(0)
  const editor = useLocation().pathname.includes("editor")
  const navigate = useNavigate()

  const results = model.searchSongs(query)
  //hint the match enter will pick, like a browser autocomplete: the sole result,
  //or - once two characters narrow a longer list - its first row, which up/down
  //then walk down to skip a song earlier in the alphabet
  const canHint = results.length === 1 || (results.length > 1 && query.trim().length >= 2)
  const selIdx = Math.max(0, Math.min(selected, results.length - 1))
  const highlightId = canHint ? results[selIdx]?.id : null

  //keep the hinted row visible as the arrows walk it past the fold
  useEffect(() => {
    document.querySelector("#sidebar .song.first")?.scrollIntoView({ block: "nearest" })
  }, [highlightId])

  function setSearch(value: string) {
    setQuery(value)
    setSelected(0)
  }

  function moveHint(delta: number) {
    if (!canHint) return
    setSelected(s => Math.max(0, Math.min(s + delta, results.length - 1)))
  }

  //enter opens the hinted match (or the sole match) and closes the sidebar -
  //the keyboard counterpart to clicking it
  function openHintedMatch() {
    const target = canHint ? results[selIdx] : null
    if (!target) return
    //drop focus back onto the page, otherwise the song's own shortcuts (ctrl+e,
    //the arrows) stay suppressed by the still-focused search box
    document.getElementById("sidebar-search")?.blur()
    navigate((editor ? "/editor/" : "/") + target.id)
    setSearch("")
    toggle()
  }

  return (
    <div
      id="sidebar"
      className={open ? "open" : ""}
      {...useSwipeable({
        onSwipedLeft: () => toggle(),
      })}
    >
      <div className="top">
        <input
          id="sidebar-search"
          size={1}
          placeholder="Search ..."
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") openHintedMatch()
            else if (e.key === "ArrowDown") { e.preventDefault(); moveHint(1) }
            else if (e.key === "ArrowUp") { e.preventDefault(); moveHint(-1) }
          }}
          value={query}
        />
        <span className="clear" onClick={()=>setSearch("")}>×</span>
        <i className="button fas fa-arrow-left" onClick={() => toggle()}></i>
      </div>

      {!!model.settings.separateFavorites&& !!model.settings.favorites.length && <>
        <div className="divider">Favorites</div>
        {results.filter(song => model.isFavorite(song.id)).map((song) => <SongLink toggle={()=>toggle()} song={song} editor={editor}/>)}
        <div className="divider">All</div>
      </>
      }
      {results.map((song) => <SongLink toggle={()=>toggle()} song={song} editor={editor} highlight={song.id === highlightId}/>)}
    </div>
  );
}

function SongLink({toggle, song, editor, highlight=false}:{toggle:()=>any, song:song, editor:boolean, highlight?:boolean}){
        return <Link to={"/" + (editor?"editor/":"") + song.id} className="notA" key={song.id}>
        <div
        className={"song" + (highlight ? " first" : "")}
        onClick={() => {
            if (isMobile() || model.settings.closeSidebarOnSongClickPC)
            toggle();
        }}
        >
        <div className="text">
            {song.title} <span className="author">{song.author}</span>
        </div>
        {!!model.settings.showFavorites && !model.settings.separateFavorites && !!model.settings.favorites.includes(song.id) && <div className="favorite">
                <i className="fas fa-star"></i>
    </div>}
        </div>
    </Link>
}